import React from "react";
import { useWatch } from "react-hook-form";
import { FieldType } from "../../../../../shared/types";
import CheckboxInput from "../../components/CheckboxInput/CheckboxInput";
import RadioInput from "../../components/RadioInput/RadioInput";
import SelectInput from "../../components/SelectInput/SelectInput";
const SelectableField = ({
  isError,
  useFormProps,
  field,
  text
}) => {
  const selectedOptions = useWatch({
    control: useFormProps?.control,
    name: field?.id
  });
  if (field?.type === FieldType.Checkbox) return /*#__PURE__*/React.createElement(CheckboxInput, {
    isError: isError,
    fieldSettings: field?.settings || {},
    registerProps: {
      ...useFormProps?.register(field?.id)
    },
    selectedOptions: selectedOptions,
    text: text
  });
  if (field?.type === FieldType.Radio) return /*#__PURE__*/React.createElement(RadioInput, {
    isError: isError,
    fieldSettings: field?.settings || {},
    registerProps: {
      ...useFormProps?.register(field?.id)
    },
    text: text
  });
  if (field?.type === FieldType.Select) return /*#__PURE__*/React.createElement(SelectInput, {
    isError: isError,
    fieldSettings: field?.settings || {},
    selectedOptions: selectedOptions,
    registerProps: {
      ...useFormProps?.register(field?.id)
    },
    control: useFormProps?.control,
    text: text
  });
  return null;
};
export default SelectableField;
//# sourceMappingURL=SelectableField.js.map